import {datatables} from '#/js/inline/datatables';

export default function () {
  datatables();

  let filterToggle = $('.filter-toggle');
  let filterClear = $('#filter-clear');

  $.fn.dataTable.ext.search.push(
    (settings, data, dataIndex) => {
      let statusIndex = $('#partnerInviteTable thead tr th').index($('th#status'));
      let status = data[statusIndex].trim();

      let filters = [];
      let elements = document.querySelectorAll('.filter-toggle.toggled');

      if (elements.length > 0) {
        filterClear.addClass('enabled');
      } else {
        filterClear.removeClass('enabled');
      }

      Array.prototype.forEach.call(elements, (element) => {
        filters.push(element.textContent.trim());
      });

      if (filters.length > 0) {
        console.log(filters, status);
        return filters.includes(status);
      }

      return true;
    },
  );

  const listTable = $('#partnerInviteTable');
  let table = listTable.DataTable({
    dom: 'Bfrtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print',
    ],
    language: {
      search: '_INPUT_',
      searchPlaceholder: window.Lang.get('general.search') + '...',
    },
    order: [[0, 'asc']],
  });

  filterToggle.click(function () {
    $(this).toggleClass('toggled');
    table.draw();
  });

  filterClear.click(function () {
    filterToggle.removeClass('toggled');
    table.draw();
  });
}
